<template>
  <div>
    <div class="addToProjectHint">
      Bitte gewünschten Beitrag zum Hinzufügen zum Projekt anklicken.
    </div>
    <div class="addToProjectHintAbort" @click="$emit('closeSelectionMap')" >
      <svgicon :icon="'close'" width="32" height="32" color="#fff"></svgicon>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AddToProjectHint'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .addToProjectHintAbort {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9999;
    line-height: 48px;
    padding: 0px 10px;
    background: $color-action;
  }

  .addToProjectHint {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    z-index: 9999;
    padding: 0px 20px;
    line-height: 48px;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    background: rgba($color-text,0.9);
    text-align:center;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
  }

</style>



// WEBPACK FOOTER //
// src/components/AddToProjectHint.vue